const CTX_ERR_MSG = 'Context Not Available. Forgot to use Context Provider?';
function assertIsDefined(val, msg = `Expected 'val' to be defined, but received ${val}`) {
    if (val === undefined || val === null)
        throw new Error(msg);
}
export function assertContext(context, contextName) {
    assertIsDefined(context, `${contextName}: ${CTX_ERR_MSG}`);
}
